import GoogleMapsLoader from 'google-maps';

GoogleMapsLoader.KEY = 'AIzaSyBWWkgYncwZ_XknqtNnB0Fb6gOsL-f_xnA';
GoogleMapsLoader.VERSION = '3.35';

const customMapStyle = [
    {
        elementType: 'geometry',
        stylers: [
            {
                color: '#f5f5f5',
            },
        ],
    },
    {
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#616161',
            },
        ],
    },
    {
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#f5f5f5',
            },
        ],
    },
    {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#bdbdbd',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
            {
                color: '#eeeeee',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#757575',
            },
        ],
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
            {
                color: '#e5e5e5',
            },
        ],
    },
    {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#9e9e9e',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#757575',
            },
        ],
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
            {
                color: '#dadada',
            },
        ],
    },
    {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#616161',
            },
        ],
    },
    {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#9e9e9e',
            },
        ],
    },
    {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [
            {
                color: '#e5e5e5',
            },
        ],
    },
    {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [
            {
                color: '#eeeeee',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
            {
                color: '#c9c9c9',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#9e9e9e',
            },
        ],
    },
];

export default {
    props: {
        longitude: Number,
        latitude: Number,
    },
    google: null,
    mapEl: null,
    map: null,
    render() {
        return this.$scopedSlots.default({
            registerMapEl: this.registerMapEl,
        });
    },
    created() {
        GoogleMapsLoader.load((google) => {
            this.$options.google = google;
            this.setupMap();
        });
    },
    methods: {
        registerMapEl({ el }) {
            this.$options.mapEl = el;
        },

        setupMap() {
            const { google, mapEl } = this.$options;

            if (!google && !mapEl) return;

            const position = {
                lat: 37.16309,
                lng: -93.31926,
            };

            this.$options.map = new google.maps.Map(mapEl, {
                center: position,
                zoom: 13,
                styles: customMapStyle,
            });

            // eslint-disable-next-line no-new
            new google.maps.Marker({
                map: this.$options.map,
                position,
            });
        },
    },
};
